module.exports = __webpack_public_path__ + "img/Atlasofemotion_2.e3b41623.png";